<template>
  <div class="account-manage">
    <sn-table :headers="headers" :tableData="data"></sn-table>
  </div>
</template>
<script>
import SnTable from '@/components/common/SnTable';

export default {
  props: {
    data: {
      type: Array
    }
  },
  data() {
    return {
      headers: [
        {
          label: '订单编号',
          key: 'trade_no'
        },
        {
          label: '订单生成日期',
          key: 'trade_time'
        },
        {
          label: '订单类型',
          key: 'product_name'
        },
        {
          label: '截止日期',
          key: 'expire_date'
        },
        {
          label: '支付金额',
          key: 'amount_paid'
        },
        {
          label: '订单状态',
          key: 'trade_status'
        }
      ]
    };
  },
  components: {
    SnTable
  }
};
</script>
<style lang="scss" scoped>
.account-manage {

}
</style>
